export default __webpack_public_path__ + "static/media/seen.73fdac1c.svg";